/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var PlaceholderView = require('common/views/PlaceholderView');

var GetComplianceByLicense = require('../services/GetComplianceByLicense');

var NonDepLicenseComplianceView = require('../views/NonDepLicenseComplianceView');

module.exports = {
  channel: 'nd',

  event: 'build:license-compliance-grid-view',

  builder: function(licenseId) {
    return new PlaceholderView({
      viewPromise: buildLicenseComplianceView(licenseId)
    });
  }
};

function buildLicenseComplianceView(licenseId) {
  var deferred = $.Deferred();

  GetComplianceByLicense(licenseId)
    .done(function(complianceCases) {
      deferred.resolve(
        new NonDepLicenseComplianceView({
          model: new Backbone.Model({
            licenseId: licenseId,
            complianceCases: complianceCases
          })
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });

  return deferred.promise();
}
